<template>

  <div id="wrapper" v-if="company">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <h3 class="font-light m-b-xs">
            Edit Company - {{company.name}}
          </h3>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="row">
        <div class="col-lg-12">
          <div class="hpanel">
            <company-information-v2 :company="company" :userId="$auth.user().id" ></company-information-v2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueLadda from 'vue-ladda'
import CompanyInformationV2 from '../../components/user/CompanyInformationV2'

export default {
  components: {
    CompanyInformationV2,
    VueLadda
  },
  name: 'CompanyEdit',
  data () {
    return {
      companyId: null,
      company: null
    }
  },
  methods: {
    initCompany: function () {
      if (this.companyId !== null) {
        this.getCompany(this.companyId)
      }
    },
    getCompany: function (companyId) {
      this.axios.get('/company/' + companyId + '?relations={keywords,files,country,industrialClassification,nbEmployees,category,contactFunction}')
        .then((response) => {
          this.company = response.data
        })
        .catch((error) => {
        })
    }
  },
  beforeMount () {
    this.companyId = typeof this.$route.params.company_id !== 'undefined' ? this.$route.params.company_id : null
    this.initCompany()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/company/CompanyEdit.vue